import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('ProcurementType?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('ProcurementType/show/'+id);
    },    
    create(params) {
        return Service().post('ProcurementType/create', params);
    },
    update(id, params) {
        return Service().post('ProcurementType/update/'+id, params);
    },
    delete(id) {
        return Service().post('ProcurementType/delete/'+id);
    }
}